const initialState = () => ({
  currentBooks: null,
  oldBooks: null,
  resources: {},
})

const bookReducer = (state = initialState()) => {
  return state
}

export default bookReducer
